@if (!isLoading()) {
    <div id="rights-component">
        <ng-container>
            @if (isNationalAdmin()) {
                <div class="rights-component_header">
                    <lib-uimm-dropdown
                        [label]="'Structure'"
                        [labelWidth]="'220px'"
                        [(items)]="structures"
                        (itemsChange)="handleStructureChange()"
                        [headers]="{
                            search: true,
                            selectAll: false,
                            count: false
                        }"
                    ></lib-uimm-dropdown>
                </div>
            }

            @if (getSelectedStructure()) {
                <div class="rights-component_main" [ngStyle]="getMainStyles(applicationsAccess)">
                    @for (
                        application of applicationsAccess;
                        track application.id;
                        let appIndex = $index
                    ) {
                        <div
                            class="application"
                            [ngStyle]="{
                                'grid-column': appIndex + 2 + ' / span 1'
                            }"
                        >
                            <span
                                [ngClass]="getApplicationIcon(application)"
                                [style.color]="getApplicationColor(application)"
                                [tooltip]="application.name"
                                tooltipColor="#199fe2"
                            ></span>
                            @if (application.users.length > 0) {
                                <div
                                    class="icon-Warning"
                                    (click)="handleClickViewExceptions($event, application)"
                                    tooltip="Exceptions"
                                    tooltipColor="#199fe2"
                                    tooltipPosition="right"
                                ></div>
                            }
                            @if (application.app_id === 'easitraining') {
                                <div class="roles-container">
                                    @for (
                                        additionalRole of additionalRolesAccess;
                                        track additionalRole.shortname
                                    ) {
                                        @if (additionalRole.shortname !== 'externalCallManager') {
                                            <div
                                                [style.color]="getApplicationColor(application)"
                                                [ngClass]="additionalRole.icon"
                                                [tooltip]="additionalRole.name"
                                            ></div>
                                        }
                                    }
                                </div>
                            }
                            @if (application.app_id === 'easicall') {
                                <div class="roles-container">
                                    @for (
                                        additionalRole of additionalRoles;
                                        track additionalRole.shortname
                                    ) {
                                        @if (additionalRole.shortname === 'externalCallManager') {
                                            <div
                                                [style.color]="getApplicationColor(application)"
                                                [ngClass]="additionalRole.icon"
                                                [tooltip]="additionalRole.name"
                                            ></div>
                                        }
                                    }
                                </div>
                            }
                        </div>
                    }

                    @for (role of roles; track role.id; let roleIndex = $index) {
                        @if (showRole(role) && applicationsAccess) {
                            <div
                                class="role"
                                [ngStyle]="{
                                    'grid-row': roleIndex + 2
                                }"
                            ></div>
                            <div
                                class="role-description"
                                [ngStyle]="{
                                    'grid-row': roleIndex + 2
                                }"
                            >
                                <span [ngClass]="role.icon"></span>{{ role.name }}
                            </div>
                            @for (
                                application of applicationsAccess;
                                track application.id;
                                let appIndex = $index
                            ) {
                                <div
                                    class="role-button"
                                    [ngStyle]="{
                                        'grid-row': roleIndex + 2,
                                        'grid-column': appIndex + 2 + ' / span 1'
                                    }"
                                    [ngClass]="getApplicationIconClass(application, role)"
                                    (click)="handleClickToggleApplicationAccess(application, role)"
                                >
                                    @if (
                                        application.users.length > 0 &&
                                        hasExceptionForRole(application, role)
                                    ) {
                                        <div
                                            class="icon-Warning"
                                            (click)="
                                                handleClickViewExceptions($event, application, role)
                                            "
                                            tooltip="Exceptions"
                                            tooltipColor="#199fe2"
                                            tooltipPosition="right"
                                        ></div>
                                    }
                                    @if (application.app_id === 'easitraining') {
                                        <div class="roles-container">
                                            @for (
                                                additionalRole of additionalRolesAccess;
                                                track additionalRole.key
                                            ) {
                                                @if (
                                                    additionalRole.shortname !==
                                                    'externalCallManager'
                                                ) {
                                                    <div
                                                        [ngClass]="
                                                            getAdditionalRoleIconClass(
                                                                role,
                                                                additionalRole
                                                            )
                                                        "
                                                        (click)="
                                                            handleClickToggleAdditionalRole(
                                                                role,
                                                                additionalRole
                                                            )
                                                        "
                                                    ></div>
                                                }
                                            }
                                        </div>
                                    }

                                    @if (application.app_id === 'easicall') {
                                        <div class="roles-container">
                                            @for (
                                                additionalRole of additionalRolesAccess;
                                                track additionalRole.key
                                            ) {
                                                @if (
                                                    additionalRole.shortname ===
                                                    'externalCallManager'
                                                ) {
                                                    <div
                                                        [ngClass]="
                                                            getAdditionalRoleIconClass(
                                                                role,
                                                                additionalRole
                                                            )
                                                        "
                                                        (click)="
                                                            handleClickToggleAdditionalRole(
                                                                role,
                                                                additionalRole
                                                            )
                                                        "
                                                    ></div>
                                                }
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        }
                    }
                </div>
            } @else {
                <div class="empty-structure">
                    <p>Veuillez sélectionner une structure.</p>
                    <div>
                        <img src="assets/img/library-default.png" />
                    </div>
                </div>
            }
        </ng-container>
    </div>
} @else {
    <app-loading></app-loading>
}
